import React from "react";
import "./Page3.css";
//-----------------------------------------
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//-----------------------------------------
import pagePhoto3 from "../images/pagePhoto3.png";
//-----------------------------------------

function Page3() {
  return (
    <div className="page3_container">
      <div className="page3_bangla">
        “Add To Basket” এ Click করে আপনার প্রয়োজনীয় এক বা একাধিক Product সিলেক্ট
        করা যাবে। সিলেক্ট করা Product এর সংখ্যা বাড়ানো বা কমানোর জন্য অথবা
        selected কোনো Product কে Cancel করার জন্য “Shopping Cart” Icon টিতে
        Click করে “Shopping Cart” pageএ যেতে হবে। এই “Shopping Cart” Icon টি
        আপনার screen 'এর ডান দিকে মাঝবরাবর অবস্থিত।
      </div>
      <div className="page3_english">
        Products as per the requirement of Customer are to be selected by
        clicking “Add To Basket” button. “Shopping Cart” icon is to be clicked
        to go to “Shopping Cart” page for editing the quantity of product
        selected or to cancel a particular selection. “Shopping Cart” icon is
        positioned on the right side midsection of your screen.
      </div>
      <div className="page3_photo_div">
        <img className="page3_photo" src={pagePhoto3} alt="PagePhoto3 Logo" />
      </div>
      {/*--------------go to page-4 (next page) starts-------------*/}
      <NavLink to="/page4" className="goto_next_page" exact>
        <span className="forwardIcon_text">Next</span>
        <ArrowForwardIcon className="next_page_icon" />
      </NavLink>
      {/*--------------go to page-4 (next page) ends-------------*/}
    </div>
  );
}

export default Page3;
